import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SETTINGS } from '../config/common.settings';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private message: NzMessageService,
    private ngxLoader: NgxUiLoaderService,
  ) {}

  getMembers(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/member?where[status][equals]=Active&page=${page}&limit=${pageSize}&sort=name`,
          {withCredentials: true}
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve members');
            reject(error);
          },
        );
    });
  }

  getMemberById(id: string): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/member/${id}`,{withCredentials: true}).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve member');
          reject(error);
        },
      );
    });
  }

  getMembersBySearch(
    name: string,
    page: number,
    pageSize: number,
  ): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/member?where[name][contains]=${name}&[status][equals]=Active&page=${page}&limit=${pageSize}`,
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve members');
            reject(error);
          },
        );
    });
  }
}
